import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { Root } from "./view/Root";

const doc  = document.getElementById("page-container");
const root = createElement(Root);

createRoot(doc).render(root);
